package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ObjectiveQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    category_id: String?,
    title: String,
    description: String?,
    motivation: String?,
    deadline: String?,
    year: Long?,
    status: String,
    progress: Long,
    skill_id: String?,
    step_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_050_058_538, arrayOf("objective"), driver, "Objective.sq",
      "selectAll",
      "SELECT objective.id, objective.category_id, objective.title, objective.description, objective.motivation, objective.deadline, objective.year, objective.status, objective.progress, objective.skill_id, objective.step_id, objective.created_at, objective.updated_at, objective.is_deleted, objective.deleted_at, objective.synced_at FROM objective WHERE is_deleted = 0 ORDER BY deadline IS NULL, deadline, created_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getString(7)!!,
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectAll(): Query<Objective> = selectAll { id, category_id, title, description,
      motivation, deadline, year, status, progress, skill_id, step_id, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Objective(
      id,
      category_id,
      title,
      description,
      motivation,
      deadline,
      year,
      status,
      progress,
      skill_id,
      step_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    category_id: String?,
    title: String,
    description: String?,
    motivation: String?,
    deadline: String?,
    year: Long?,
    status: String,
    progress: Long,
    skill_id: String?,
    step_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getString(7)!!,
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectById(id: String): Query<Objective> = selectById(id) { id_, category_id, title,
      description, motivation, deadline, year, status, progress, skill_id, step_id, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Objective(
      id_,
      category_id,
      title,
      description,
      motivation,
      deadline,
      year,
      status,
      progress,
      skill_id,
      step_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByCategory(category_id: String?, mapper: (
    id: String,
    category_id: String?,
    title: String,
    description: String?,
    motivation: String?,
    deadline: String?,
    year: Long?,
    status: String,
    progress: Long,
    skill_id: String?,
    step_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByCategoryQuery(category_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getString(7)!!,
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByCategory(category_id: String?): Query<Objective> =
      selectByCategory(category_id) { id, category_id_, title, description, motivation, deadline,
      year, status, progress, skill_id, step_id, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Objective(
      id,
      category_id_,
      title,
      description,
      motivation,
      deadline,
      year,
      status,
      progress,
      skill_id,
      step_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByStatus(status: String, mapper: (
    id: String,
    category_id: String?,
    title: String,
    description: String?,
    motivation: String?,
    deadline: String?,
    year: Long?,
    status: String,
    progress: Long,
    skill_id: String?,
    step_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByStatusQuery(status) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getString(7)!!,
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByStatus(status: String): Query<Objective> = selectByStatus(status) { id,
      category_id, title, description, motivation, deadline, year, status_, progress, skill_id,
      step_id, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Objective(
      id,
      category_id,
      title,
      description,
      motivation,
      deadline,
      year,
      status_,
      progress,
      skill_id,
      step_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    category_id: String?,
    title: String,
    description: String?,
    motivation: String?,
    deadline: String?,
    year: Long?,
    status: String,
    progress: Long,
    skill_id: String?,
    step_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-208_368_869, arrayOf("objective"), driver, "Objective.sq",
      "selectDirty",
      "SELECT objective.id, objective.category_id, objective.title, objective.description, objective.motivation, objective.deadline, objective.year, objective.status, objective.progress, objective.skill_id, objective.step_id, objective.created_at, objective.updated_at, objective.is_deleted, objective.deleted_at, objective.synced_at FROM objective WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getString(7)!!,
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectDirty(): Query<Objective> = selectDirty { id, category_id, title, description,
      motivation, deadline, year, status, progress, skill_id, step_id, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Objective(
      id,
      category_id,
      title,
      description,
      motivation,
      deadline,
      year,
      status,
      progress,
      skill_id,
      step_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    category_id: String?,
    title: String,
    description: String?,
    motivation: String?,
    deadline: String?,
    year: Long?,
    status: String,
    progress: Long,
    skill_id: String?,
    step_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getString(7)!!,
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Objective> = selectByIdAnyState(id) { id_,
      category_id, title, description, motivation, deadline, year, status, progress, skill_id,
      step_id, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Objective(
      id_,
      category_id,
      title,
      description,
      motivation,
      deadline,
      year,
      status,
      progress,
      skill_id,
      step_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByStep(step_id: String?, mapper: (
    id: String,
    category_id: String?,
    title: String,
    description: String?,
    motivation: String?,
    deadline: String?,
    year: Long?,
    status: String,
    progress: Long,
    skill_id: String?,
    step_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByStepQuery(step_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getLong(6),
      cursor.getString(7)!!,
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByStep(step_id: String?): Query<Objective> = selectByStep(step_id) { id,
      category_id, title, description, motivation, deadline, year, status, progress, skill_id,
      step_id_, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Objective(
      id,
      category_id,
      title,
      description,
      motivation,
      deadline,
      year,
      status,
      progress,
      skill_id,
      step_id_,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    category_id: String?,
    title: String,
    description: String?,
    motivation: String?,
    deadline: String?,
    year: Long?,
    status: String,
    progress: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_791_231_820, """
        |INSERT INTO objective(id, category_id, title, description, motivation, deadline, year, status, progress, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 11) {
          bindString(0, id)
          bindString(1, category_id)
          bindString(2, title)
          bindString(3, description)
          bindString(4, motivation)
          bindString(5, deadline)
          bindLong(6, year)
          bindString(7, status)
          bindLong(8, progress)
          bindLong(9, created_at)
          bindLong(10, updated_at)
        }
    notifyQueries(-1_791_231_820) { emit ->
      emit("objective")
    }
  }

  public fun update(
    category_id: String?,
    title: String,
    description: String?,
    motivation: String?,
    deadline: String?,
    year: Long?,
    status: String,
    progress: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_446_285_628, """
        |UPDATE objective
        |SET category_id = ?, title = ?, description = ?, motivation = ?, deadline = ?, year = ?, status = ?, progress = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 10) {
          bindString(0, category_id)
          bindString(1, title)
          bindString(2, description)
          bindString(3, motivation)
          bindString(4, deadline)
          bindLong(5, year)
          bindString(6, status)
          bindLong(7, progress)
          bindLong(8, updated_at)
          bindString(9, id)
        }
    notifyQueries(-1_446_285_628) { emit ->
      emit("objective")
    }
  }

  public fun updateProgress(
    progress: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_662_095_633,
        """UPDATE objective SET progress = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, progress)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_662_095_633) { emit ->
      emit("objective")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-746_987_792,
        """UPDATE objective SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-746_987_792) { emit ->
      emit("objective")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-553_231_373,
        """UPDATE objective SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-553_231_373) { emit ->
      emit("objective")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(-927_049_999, """DELETE FROM objective WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-927_049_999) { emit ->
      emit("milestone")
      emit("objective")
      emit("objective_progress_history")
      emit("project")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(455_905_826,
        """UPDATE objective SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(455_905_826) { emit ->
      emit("objective")
    }
  }

  public fun updateSkill(
    skill_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-983_366_163,
        """UPDATE objective SET skill_id = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, skill_id)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-983_366_163) { emit ->
      emit("objective")
    }
  }

  public fun updateStep(
    step_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-447_354_960,
        """UPDATE objective SET step_id = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, step_id)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-447_354_960) { emit ->
      emit("objective")
    }
  }

  public fun setSkillAndStep(
    skill_id: String?,
    step_id: String?,
    id: String,
  ) {
    driver.execute(-93_203_559, """UPDATE objective SET skill_id = ?, step_id = ? WHERE id = ?""",
        3) {
          bindString(0, skill_id)
          bindString(1, step_id)
          bindString(2, id)
        }
    notifyQueries(-93_203_559) { emit ->
      emit("objective")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("objective", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("objective", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_807_882_391,
        """SELECT objective.id, objective.category_id, objective.title, objective.description, objective.motivation, objective.deadline, objective.year, objective.status, objective.progress, objective.skill_id, objective.step_id, objective.created_at, objective.updated_at, objective.is_deleted, objective.deleted_at, objective.synced_at FROM objective WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Objective.sq:selectById"
  }

  private inner class SelectByCategoryQuery<out T : Any>(
    public val category_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("objective", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("objective", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT objective.id, objective.category_id, objective.title, objective.description, objective.motivation, objective.deadline, objective.year, objective.status, objective.progress, objective.skill_id, objective.step_id, objective.created_at, objective.updated_at, objective.is_deleted, objective.deleted_at, objective.synced_at FROM objective WHERE category_id ${ if (category_id == null) "IS" else "=" } ? AND is_deleted = 0 ORDER BY deadline IS NULL, deadline""",
        mapper, 1) {
      bindString(0, category_id)
    }

    override fun toString(): String = "Objective.sq:selectByCategory"
  }

  private inner class SelectByStatusQuery<out T : Any>(
    public val status: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("objective", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("objective", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-52_833_472,
        """SELECT objective.id, objective.category_id, objective.title, objective.description, objective.motivation, objective.deadline, objective.year, objective.status, objective.progress, objective.skill_id, objective.step_id, objective.created_at, objective.updated_at, objective.is_deleted, objective.deleted_at, objective.synced_at FROM objective WHERE status = ? AND is_deleted = 0 ORDER BY deadline IS NULL, deadline""",
        mapper, 1) {
      bindString(0, status)
    }

    override fun toString(): String = "Objective.sq:selectByStatus"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("objective", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("objective", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-2_049_671_026,
        """SELECT objective.id, objective.category_id, objective.title, objective.description, objective.motivation, objective.deadline, objective.year, objective.status, objective.progress, objective.skill_id, objective.step_id, objective.created_at, objective.updated_at, objective.is_deleted, objective.deleted_at, objective.synced_at FROM objective WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Objective.sq:selectByIdAnyState"
  }

  private inner class SelectByStepQuery<out T : Any>(
    public val step_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("objective", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("objective", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT objective.id, objective.category_id, objective.title, objective.description, objective.motivation, objective.deadline, objective.year, objective.status, objective.progress, objective.skill_id, objective.step_id, objective.created_at, objective.updated_at, objective.is_deleted, objective.deleted_at, objective.synced_at FROM objective WHERE step_id ${ if (step_id == null) "IS" else "=" } ? AND is_deleted = 0 ORDER BY created_at""",
        mapper, 1) {
      bindString(0, step_id)
    }

    override fun toString(): String = "Objective.sq:selectByStep"
  }
}
